module.exports = __webpack_public_path__ + "img/u3087.846fcd9e.jpg";